module.exports = __webpack_public_path__ + "img/901323220.39e8e84e.png";